import React, { useEffect, useRef } from "react";
import type { GoogleAdProps } from "@/types/adsense";

const GoogleAd: React.FC<GoogleAdProps> = ({
  adSlot,
  adFormat = "auto",
  adLayout,
  adLayoutKey,
  fullWidthResponsive = true,
  className = "",
  style,
  placeholder,
}) => {
  const adRef = useRef<HTMLDivElement>(null);
  const isAdLoaded = useRef(false);

  useEffect(() => {
    if (isAdLoaded.current) return;

    try {
      if (typeof window !== "undefined" && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        isAdLoaded.current = true;
      }
    } catch (error) {
      console.error("AdSense error:", error);
    }
  }, []);

  const publisherId = process.env.NEXT_PUBLIC_ADSENSE_PUBLISHER_ID;
  const isEnabled = process.env.NEXT_PUBLIC_ADSENSE_ENABLED === "true";

  if (!isEnabled || !publisherId) {
    return placeholder ? <>{placeholder}</> : null;
  }

  return (
    <div ref={adRef} className={`ad-container ${className}`} style={style}>
      <ins
        className="adsbygoogle"
        style={{ display: "block", ...(style || {}) }}
        data-ad-client={publisherId}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        {...(adLayout && { "data-ad-layout": adLayout })}
        {...(adLayoutKey && { "data-ad-layout-key": adLayoutKey })}
        data-full-width-responsive={fullWidthResponsive}
      />
    </div>
  );
};

export default GoogleAd;
